var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'w-full': !!_vm.ratio
    },
    style: _vm.wrapperStyle
  }, [_c('div', {
    staticClass: "flex items-center justify-center",
    class: {
      'absolute top-0 left-0 right-0 bottom-0': !!_vm.ratio
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }